// Guarda de "a resposta mais nova vence", para chamadas que podem ficar em voo ao mesmo
// tempo. O reload do painel é disparado por boot, rajada de realtime, pós-ação e
// retentativa; sem isso, a resposta de uma chamada antiga podia chegar depois da nova e
// sobrescrever a tela com estado velho (o AbortedError existe para o mesmo fim nas
// chamadas que dá para cancelar de verdade).
export interface LatestRequestGuard {
  /** Abre uma requisição e invalida as anteriores. */
  begin(): number
  /** A resposta deste token ainda é a mais nova? */
  isCurrent(token: number): boolean
}

export function createLatestRequestGuard(): LatestRequestGuard {
  // 0 = nenhuma requisição aberta: token que nunca foi emitido não é "atual".
  let current = 0
  return {
    begin() {
      current += 1
      return current
    },
    isCurrent(token) {
      return current !== 0 && token === current
    },
  }
}
